




import { Component } from 'vue-property-decorator';
import IconMixin from '@/components/Helper/Icon/icon.mixin';
import SvgIcon from '@/components/Helper/Icon/SvgIcon.vue';

@Component<LanguagesIcon>({
  components: { SvgIcon },
})
export default class LanguagesIcon extends IconMixin {
  paths: string[] = [
    'm0 18.916v364.19h295.173l73.391 109.979 72.263-109.979h71.173v-364.19zm482 334.19h-57.359l-56.271 85.641-57.15-85.641h-281.22v-304.19h452z',
    'm226.637 317.291c76.574 19.299 151.757-39.706 148.705-119.943-2.062-54.332-40.345-98.297-89.979-110.807-45.723-11.524-92.924 4.876-121.811 40.03-54.905 66.817-22.133 169.253 63.085 190.72zm116.706-134.375h-40.414c-.433-20.579-1.572-40.384-3.364-58.703 22.143 12.381 38.27 33.833 43.778 58.703zm-40.282 30h41.688c-3.521 28.397-20.51 53.118-45.191 66.781 2.033-20.718 3.22-43.302 3.503-66.781zm-59.31-99.164c7.906-1.074 16.004-1.155 24.497 0 2.55 20.89 4.134 44.397 4.673 69.164h-33.844c.539-24.754 2.124-48.269 4.674-69.164zm29.309 99.164c-.344 27.68-1.982 53.978-4.813 77.158-8.1 1.093-16.393 1.094-24.494 0-2.83-23.177-4.468-49.475-4.812-77.157h34.119zm-60.625-88.704c-1.793 18.323-2.932 38.131-3.364 58.703h-40.414c5.506-24.868 21.633-46.321 43.778-58.703zm-3.496 88.704c.283 23.481 1.47 46.064 3.501 66.781-24.68-13.663-41.669-38.383-45.19-66.781z',
  ];
}
